exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zdlAgZuyojz0fhDaUKadm{margin:30px auto 0 auto;width:333px;border-radius:45px;border:5px solid #30323a;background-color:#212121}.kXywttIf75HoqrI1wZlWO{margin:-3px;border:2px solid black;border-radius:45px;background-color:#212121;padding:60px 14px 100px 14px}._1bWqh4T1yCq7Yjt2V9Jifh{height:500px;width:100%;margin:0;padding:0;border:none;border-radius:4px}\n", ""]);

// Exports
exports.locals = {
	"previewContainer": "zdlAgZuyojz0fhDaUKadm",
	"previewInner": "kXywttIf75HoqrI1wZlWO",
	"previewIframe": "_1bWqh4T1yCq7Yjt2V9Jifh"
};